<template>
    <b-select
        v-bind="$attrs"
        :value="value"
        @input="value => $emit('input', value)">
        <option :value="{
          name: null,
          details: {
            theoretical: null,
            department: null,
            type: null
          }
        }" v-if="allowEmpty">
            Любая дисциплина
        </option>
        <template v-if="restrict == null || restrict == 'main'">
            <option :value="{
                name: 'main',
                details: {
                    theoretical: true
                }
            }">
                Основная теоретическая
            </option>
            <option :value="{
                name: 'main',
                details: {
                    theoretical: false
                }
            }">
                Основная практическая
            </option>
        </template>
        <optgroup label="Дисциплина кафедры"
            v-if="restrict == null || restrict == 'department'">
            <option :value="{ name: 'department' }" v-if="allowEmpty">
                Любая кафедра
            </option>
            <option
                :key="department.id"
                :value="{
                    name: 'department',
                    details: {
                        department: {
                            id: department.id
                        }
                    }
                }"
                v-for="department in departments">
                {{ department.name }}
            </option>
        </optgroup>
        <optgroup label="Другое"
            v-if="restrict == null || restrict == 'generic'">
            <option :value="{
                name: 'generic',
                details: {
                    type: 'practice'
                }
            }">
                Практика
            </option>
            <option :value="{
                name: 'generic',
                details: {
                    type: 'attestation'
                }
            }">
                Итоговая аттестация
            </option>
        </optgroup>
    </b-select>
</template>

<script>
export default {
  props: {
    allowEmpty: Boolean,
    restrict: String,
    departments: Array,
    value: Object
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/subject/components/SubjectTypeSelect.vue